module.exports = __webpack_public_path__ + "img/ic_bed_mode_memory.50b3962d.png";